import { render, staticRenderFns } from "./Steup.vue?vue&type=template&id=6530fb9d"
import script from "./Steup.vue?vue&type=script&lang=js"
export * from "./Steup.vue?vue&type=script&lang=js"
import style0 from "./Steup.vue?vue&type=style&index=0&id=6530fb9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports